import { MenuItem, Typography, styled } from '@mui/material';

export const PageW = styled('div')`
  display: flex;
  flex-direction: column;
  padding-left: 38px;
  padding-top: 64px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 80px 16px;
  }

  @media (min-width: 1920px) {
    align-items: center;
  }
`;

export const ContentW = styled('div')`
  width: 1065px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const SectionTitle = styled(Typography)`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const FilterMenuItem = styled(MenuItem)`
  font-size: 14px;

  &&:hover {
    background-color: ${({ theme }) => theme.palette.info.light};
  }

  &&.Mui-selected {
    background-color: ${({ theme }) => theme.palette.info.p020};
  }

  &&.Mui-selected:hover {
    background-color: ${({ theme }) => theme.palette.info.p030};
  }
`;

export const SectionW = styled('div')`
  margin-top: 24px;
  padding-top: 16px;
`;

export const SectionLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 12px;
`;

export const DocsGridW = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const MediaSectionW = styled('div')`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  padding-top: 16px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const MediaColumnW = styled('div')`
  flex: 1;
  min-width: 0;
`;

export const AttachmentsW = styled('div')`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  row-gap: 8px;
  margin-top: 8px;
`;

export const AttachmentsSectionW = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.white.main};
  margin-top: 24px;
  padding: 32px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const PageTitle = styled('div')`
  margin: 0;
  white-space: nowrap;
  margin: 0;
  white-space: nowrap;
  font-size: 24px;
  font-weight: 700;
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
